<template>
    <div>
        <el-table
                class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column  prop="vc_name" label="名称" show-overflow-tooltip></el-table-column>
            <el-table-column label="初始化"  align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.to!='yy'" :disabled="scope.row.disablednb" size="mini" type="text" @click="chushihuaFun(scope.row,'nb',scope.$index)" >南北</el-button>
                    <el-button v-if="scope.row.to!='nb'" :disabled="scope.row.disabledyy" size="mini" type="text" @click="chushihuaFun(scope.row,'yy',scope.$index)" >用友</el-button>
                </template>
            </el-table-column></el-table>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "index",
        components: {},
        props: {},
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                tableData:[
                    {i_id:1,vc_name:'客户',to:'yy'},
                    {i_id:2,vc_name:'供应商',to:'yy'},
                    {i_id:3,vc_name:'部门',to:'all'},
                    {i_id:4,vc_name:'人员',to:'all'},
                    {i_id:5,vc_name:'产品规格',to:'all'},
                    {i_id:6,vc_name:'公司银行账户',to:'nb'},
                    {i_id:7,vc_name:'产品分类',to:'nb'},
                    {i_id:8,vc_name:'客商',to:'nb'},
                    {i_id:9,vc_name:'客商银行信息',to:'nb'},
                    {i_id:10,vc_name:'联系人信息',to:'nb'},
                    {i_id:11,vc_name:'基础银行',to:'nb'},
                    // {i_id:1,vc_name:'计量单位'},
                    // {i_id:1,vc_name:'银行账号 '},
                ],
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            chushihuaFun(row,type,index){
                let text;
                if (type=='nb'){
                    text='南北'
                }else if (type=='yy'){
                    text='用友'
                }
                this.$confirm('是否将'+row.vc_name+'同步到'+text+'系统','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:"warning"
                }).then(()=>{
                    // row.disabled=true;

                    console.log(this.tableData[index],'table');
                    this.chushihua(row,type,index)
                }).catch(()=>{
                    this.$message.info('取消操作')
                })
            },
            async chushihua(row,type,index){
                if (type=='nb'){
                    this.$set(this.tableData[index],'disablednb',true);

                }else if (type=='yy'){
                    this.$set(this.tableData[index],'disabledyy',true);

                }
                let param={

                };
                let res='';
                if(type=='nb'){
                    if(row.i_id==3){
                        res=await API.initializeSnDepartment(param);
                    }else if(row.i_id==4){
                        res=await API.initializeSnUser(param);
                    }else if(row.i_id==5){
                        res=await API.initializeSnProductSpecification(param);
                    }else if(row.i_id==6){
                        res=await API.initializeSnCompanyBankAccount(param);
                    }else if(row.i_id==7){
                        res=await API.initializeSnProductClassify(param);
                    }else if(row.i_id==8){
                        res=await API.initializeSnCustomer(param);
                    }else if(row.i_id==9){
                        res=await API.initializeSnCustomerBankAccount(param);
                    }else if(row.i_id==10){
                        res=await API.initializeSnCustomerContact(param);
                    }else if(row.i_id==11){
                        res=await API.initializeSnBank(param);
                    }

                }else if (type=='yy'){
                    if(row.i_id==1){
                        res=await API.initializeCustomer(param);
                    }else if(row.i_id==2){
                        res=await API.initializeSupplier(param);
                    }else if(row.i_id==3){
                        res=await API.initializeDepartment(param);
                    }else if(row.i_id==4){
                        res=await API.initializeUser(param);
                    }else if(row.i_id==5){
                        res=await API.initializePz(param);
                    }

                }
                if ( res.code == 1 ){
                    if (type=='nb'){
                        this.$set(this.tableData[index],'disablednb',false);

                    }else if (type=='yy'){
                        this.$set(this.tableData[index],'disabledyy',false);

                    }

                    this.$message.success(res.message);
                }else if (res.code == -2) {
                    if (type=='nb'){
                        this.$set(this.tableData[index],'disablednb',false);

                    }else if (type=='yy'){
                        this.$set(this.tableData[index],'disabledyy',false);

                    }
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    if (type=='nb'){
                        this.$set(this.tableData[index],'disablednb',false);

                    }else if (type=='yy'){
                        this.$set(this.tableData[index],'disabledyy',false);

                    }
                    this.$message.error(res.message);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>